import { LoadingSmall } from "@/components/LoadingSmall";
import { getArea } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { AppSelect, Option } from "@/components/ui/app-select";

export const AreaSelect: React.FC<{
  onChange: (intId: number) => void;
  value?: number;
}> = ({ onChange, value }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);
  const { data, isLoading } = useQuery({
    queryKey: ["getArea", activeFirm?.firmGuid],
    queryFn: () => getArea(String(activeFirm?.firmGuid)),
  });

  const areaData = data?.data?.result || [];

  if (isLoading) return <LoadingSmall />;

  const selectedArea = areaData.find((a) => a.intId === value);

  const options: Option[] = (data?.data?.result || []).map(
    (area) =>
      ({
        value: area.intId.toString(),
        label: `${area.name}`,
      } satisfies Option)
  );

  return (
    <AppSelect
      value={selectedArea?.intId?.toString() || ""}
      onChange={(value) => onChange(Number(value))}
      options={options}
      placeholder={t("entities.area")}
    />
  );
};
